module.exports = __webpack_public_path__ + "img/loginLeft.9cdacf77.png";